// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app[data-v-09596e33]{background:#fff;overflow:hidden;position:relative}.app[data-v-09596e33],.app .mainBox[data-v-09596e33]{width:100%;height:100%}.app .mainBox[data-v-09596e33]{position:absolute;top:0;left:0;overflow:auto}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
